import { render, staticRenderFns } from "./UseTemp.vue?vue&type=template&id=51727685&scoped=true&"
import script from "./UseTemp.vue?vue&type=script&lang=js&"
export * from "./UseTemp.vue?vue&type=script&lang=js&"
import style0 from "./UseTemp.vue?vue&type=style&index=0&id=51727685&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51727685",
  null
  
)

export default component.exports